import { atom } from 'recoil';

export const progressTrackerAtom = atom({
    key: 'progressTrackerAtom',
    default: {},
});
